import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import routes from "../api/routes";
import { messageShow } from "../../common/api/actions";
import BrandedLoading from "../../common/BrandedLoading";
import {
  Button,
  Typography,
  Tooltip,
  IconButton,
  TextField,
  InputAdornment,
  Grid,
  Box,
  Select,
  MenuItem,
  Modal,
  Chip,
  Pagination,
  List,
  ListItem,
  ListItemText,
  Paper
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SparklesIcon from "@mui/icons-material/AutoAwesome";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import ArticleIcon from "@mui/icons-material/Article";
import MovieIcon from "@mui/icons-material/Movie";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import UserIcon from "@mui/icons-material/Person";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import NewsletterIcon from "@mui/icons-material/Email";
import DOMPurify from 'dompurify';
import { generateBlogFromNews } from '../api/actions/aiActions';
import { getCms, getCategories } from '../api/actions/query';
import { removeCms, createOrUpdateCms, createOrUpdateCategory, removeCategory } from "../api/actions/mutation"
import { createEvent, sendFbPost, sendNewsletterCampaign } from "../../marketing/api/action/mutation";
import { checkPermission } from "../../common/Sidebar/checkPermission";
import { restoreImageHostInContent, resolveImageUrl } from '../../common/HtmlEditor';
import CodeSnippetHelper from './CodeSnippetHelper';

const getYouTubeEmbedUrl = (url) => {
  if (!url) return '';
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) 
    ? `https://www.youtube.com/embed/${match[2]}` 
    : url;
};

class CmsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cmsData: [],
      isLoading: true,
      searchQuery: '',
      filter: 'All', 
      isPreviewOpen: false,
      previewData: null,
      page: 1,
      rowsPerPage: 9,
      statusFilter: 'All',
      allCategories: [],
      permissions:{
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      viewMode: localStorage.getItem('cmsViewMode') || 'grid',
      isCategoryModalOpen: false,
      categoryModalMode: 'create',
      editingCategory: null,
      categoryNameInput: '',
      categoryRoute: '',
      seoKeywordInput: '',
      newsletterPublishModal: { open: false, item: null },
      unpublishModal: { open: false, item: null }
    };
  }

  componentDidMount() {
    this.fetchCmsData();
    this.verifyPermissions();
  }

  verifyPermissions = async () =>{
      const modulePermissions = await checkPermission("marketing", "resource");
      this.setState({permissions:{canView:modulePermissions.canView,canCreate:modulePermissions.canCreate,canEdit:modulePermissions.canEdit,canDelete:modulePermissions.canDelete}});
  }

  fetchCmsData = async () => {
    const { getCms, getCategories } = this.props;
    this.setState({ isLoading: true });
    try {
      const [cmsResponse, catResponse] = await Promise.all([getCms(), getCategories()]);
      
      if (cmsResponse.data.success && catResponse.data.success) {
        this.setState({
          cmsData: cmsResponse.data.data || [],
          allCategories: catResponse.data.data || [],
          isLoading: false
        });
      }
    } catch (error) {
      console.error('Error fetching CMS data:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleDelete = async (cmsId) => {
    const { messageShow, removeCms } = this.props;

    const confirmDelete = window.confirm(
      `Are you sure you want to delete this content?`
    );

    if (!confirmDelete) return;

    try {
      const response = await removeCms({ cmsId });
      if (response.data.success) {
        messageShow(response.data.message);
        this.setState(prevState => ({
          cmsData: prevState.cmsData.filter(item => item._id !== cmsId),
          isPreviewOpen: prevState.previewData && prevState.previewData._id === cmsId ? false : prevState.isPreviewOpen,
          previewData: prevState.previewData && prevState.previewData._id === cmsId ? null : prevState.previewData
        }));
      }
    } catch (error) {
      console.error("Error deleting content:", error);
      messageShow("Error deleting content")
    }
  };

  handleToggleStatus = (item) => {
    const isCurrentlyPublished = item.status === 'published';
    const isNewsletter = (item.category?.toLowerCase() === 'newsletter' || item.type === 'newsletter');

    if (!isCurrentlyPublished) {
      if (isNewsletter) {
        this.setState({ newsletterPublishModal: { open: true, item } });
      } else {
        this.executePublish(item);
      }
    } else {
      this.setState({ unpublishModal: { open: true, item } });
    }
  };

  executePublish = async (item) => {
    const { messageShow, createOrUpdateCms } = this.props;
    try {
      this.setState({ isLoading: true });
      const response = await createOrUpdateCms({
        ...item,
        status: 'published'
      });
      if (response.data && response.data.success) {
        messageShow("Content published successfully.");
        this.setState(prevState => ({
          cmsData: prevState.cmsData.map(i => i._id === item._id ? { ...i, status: 'published' } : i),
          previewData: prevState.previewData && prevState.previewData._id === item._id ? { ...prevState.previewData, status: 'published' } : prevState.previewData,
          isLoading: false
        }));
      } else {
        messageShow(response?.data?.message || "Failed to publish content.");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error publishing content:", error);
      messageShow("Error publishing content");
      this.setState({ isLoading: false });
    }
  };

  executeNewsletterPublish = async (item, sendToSubscribers) => {
    const { messageShow, createOrUpdateCms } = this.props;
    this.setState({ newsletterPublishModal: { open: false, item: null }, isLoading: true });

    try {
      const response = await createOrUpdateCms({
        ...item,
        status: 'published',
        isSent: sendToSubscribers ? true : (item.isSent || false)
      });

      if (response.data && response.data.success) {
        if (sendToSubscribers) {
          try {
            await sendNewsletterCampaign(item._id);
            messageShow("Newsletter published and email campaign sent to subscribers!");
          } catch (campaignErr) {
            console.error("[CMS List] Failed to trigger campaign during status toggle:", campaignErr);
            messageShow("Newsletter published, but email campaign trigger failed.");
          }
        } else {
          messageShow("Newsletter published (email campaign was not sent).");
        }

        this.setState(prevState => ({
          cmsData: prevState.cmsData.map(i => i._id === item._id ? { ...i, status: 'published', isSent: sendToSubscribers ? true : i.isSent } : i),
          previewData: prevState.previewData && prevState.previewData._id === item._id ? { ...prevState.previewData, status: 'published', isSent: sendToSubscribers ? true : prevState.previewData.isSent } : prevState.previewData,
          isLoading: false
        }));
      } else {
        messageShow(response?.data?.message || "Error updating content status");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      messageShow("Error updating content status");
      this.setState({ isLoading: false });
    }
  };

  executeUnpublish = async (item) => {
    const { messageShow, createOrUpdateCms } = this.props;
    this.setState({ unpublishModal: { open: false, item: null }, isLoading: true });

    try {
      const response = await createOrUpdateCms({
        ...item,
        status: 'draft'
      });

      if (response.data && response.data.success) {
        messageShow("Content moved to draft.");
        this.setState(prevState => ({
          cmsData: prevState.cmsData.map(i => i._id === item._id ? { ...i, status: 'draft' } : i),
          previewData: prevState.previewData && prevState.previewData._id === item._id ? { ...prevState.previewData, status: 'draft' } : prevState.previewData,
          isLoading: false
        }));
      } else {
        messageShow(response?.data?.message || "Error updating content status");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error unpublishing content:", error);
      messageShow("Error updating content status");
      this.setState({ isLoading: false });
    }
  };

  handleRenameCategory = async (cat, newName) => {
    const { createOrUpdateCategory, messageShow } = this.props;
    const { categoryRoute } = this.state;
    const newSlug = newName.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    const oldSlug = cat.slug;

    this.setState({ isLoading: true });
    try {
      const response = await createOrUpdateCategory({
        _id: cat._id,
        name: newName.trim(),
        slug: newSlug,
        route: categoryRoute || `/${newSlug}`
      });

      if (response.data.success) {
        const updatedCategory = response.data.data;
        this.setState(prevState => ({
          allCategories: prevState.allCategories.map(c => c._id === cat._id ? updatedCategory : c),
          cmsData: prevState.cmsData.map(item => (item.category || '').toLowerCase() === oldSlug ? { ...item, category: newSlug } : item),
          filter: prevState.filter === oldSlug ? newSlug : prevState.filter,
          isLoading: false
        }));
        this.handleCategoryModalClose();
        messageShow(`Renamed category to "${newName}" with route ${categoryRoute || `/${newSlug}`}`);
      } else {
        // Handle API error response
        messageShow(response.data.message || "Error renaming category");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error(error);
      messageShow("Error renaming category");
      this.setState({ isLoading: false });
    }
  }



  isCoreCategory = (cat) => {
    if (!cat) return false;
    const name = (cat.name || '').trim().toLowerCase();
    const slug = (cat.slug || '').trim().toLowerCase();
    const core = ['blog', 'event', 'events', 'newsletter', 'social'];
    return core.includes(name) || core.includes(slug);
  }

  handleDeleteCategory = async (cat) => {
    const { removeCategory, messageShow } = this.props;
    const catSlug = cat.slug;

    if (this.isCoreCategory(cat)) {
      messageShow("Core system categories (Blog, Event, Newsletter) cannot be deleted.");
      return;
    }

    this.setState({ isLoading: true });
    try {
      const response = await removeCategory({ categoryId: cat._id });
      if (response.data.success) {
        this.setState(prevState => ({
          allCategories: prevState.allCategories.filter(c => c._id !== cat._id),
          cmsData: prevState.cmsData.map(item => (item.category || '').toLowerCase() === catSlug ? { ...item, category: 'general' } : item),
          filter: prevState.filter === catSlug ? 'All' : prevState.filter,
          isLoading: false
        }));
        messageShow(`Deleted category "${cat.name}"`);
      }
    } catch (error) {
      console.error(error);
      messageShow("Error deleting category");
      this.setState({ isLoading: false });
    }
  }

  handleAddCategory = async (name) => {
    const { createOrUpdateCategory, messageShow } = this.props;
    const { categoryRoute } = this.state;
    const slug = name.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    
    this.setState({ isLoading: true });
    try {
      const response = await createOrUpdateCategory({
        name: name.trim(),
        slug,
        route: categoryRoute || `/${slug}`
      });
      if (response.data.success) {
        const newCat = response.data.data;
        this.setState(prevState => ({
          allCategories: [...prevState.allCategories, newCat],
          isLoading: false
        }));
        this.handleCategoryModalClose();
        messageShow(`Added category "${name}" with route ${categoryRoute || `/${slug}`}`);
      } else {
        // Handle API error response
        messageShow(response.data.message || "Error adding category");
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error(error);
      messageShow("Error adding category");
      this.setState({ isLoading: false });
    }
  }

  handleCategoryModalOpen = (mode, cat = null) => {
    if (cat) {
      // Load existing category data
      this.setState({
        isCategoryModalOpen: true,
        categoryModalMode: mode,
        editingCategory: cat,
        categoryNameInput: cat.name,
        categoryRoute: cat.route || `/${cat.slug}`
      });
    } else {
      // Reset for new category
      this.setState({
        isCategoryModalOpen: true,
        categoryModalMode: mode,
        editingCategory: null,
        categoryNameInput: '',
        categoryRoute: '',
        seoKeywordInput: ''
      });
    }
  }

  handleCategoryModalClose = () => {
    this.setState({ 
      isCategoryModalOpen: false, 
      categoryNameInput: '', 
      editingCategory: null,
      categoryRoute: '',
      seoKeywordInput: ''
    });
  }

  handleCategoryModalSubmit = () => {
    const { categoryModalMode, categoryNameInput, editingCategory } = this.state;
    if (categoryModalMode === 'create') {
      this.handleAddCategory(categoryNameInput);
    } else if (categoryModalMode === 'edit' && editingCategory) {
      this.handleRenameCategory(editingCategory, categoryNameInput);
    }
  }


  handleViewModeChange = (mode) => {
    this.setState({ viewMode: mode });
    localStorage.setItem('cmsViewMode', mode);
  }

  getCategoryName = (slugOrId) => {
    if (!slugOrId) return 'General';
    const { allCategories } = this.state;
    const val = String(slugOrId).trim();
    const cat = allCategories.find(c => 
      c.slug === val || 
      c._id === val || 
      (c.name && c.name.toLowerCase() === val.toLowerCase())
    );
    if (cat) return cat.name;
    const fallback = val;
    return /^[a-fA-F0-9]{24}$/.test(fallback) ? 'Category' : fallback.replace(/-/g, ' ');
  }

  renderCmsPreview = (data) => {
    const isNewsletter = data.category?.toLowerCase() === 'newsletter' || data.type === 'newsletter';

    return (
      <Box sx={{ p: 4 }}>
        {data.thumbnail && (
          <Box sx={{ width: '100%', height: 350, mb: 4, borderRadius: 2, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
            <img
              src={resolveImageUrl(data.thumbnail)}
              alt="Hero"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
        )}

        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
            <Chip
              label={this.getCategoryName(data.category).toUpperCase()}
              size="small"
              sx={{ fontWeight: 700, fontSize: '0.65rem', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.1)', border: 'none' }}
            />
            {data.sort !== undefined && (
                <Chip
                    label={`ORDER: ${data.sort}`}
                    size="small"
                    sx={{ fontWeight: 700, fontSize: '0.65rem', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.1)', border: 'none' }}
                />
            )}
          </Box>

          <Typography variant="h4" sx={{ fontWeight: 700, color: '#1F2937', lineHeight: 1.3, mb: 1 }}>
            {data.title}
          </Typography>
          {data.subtitle && (
              <Typography variant="h6" sx={{ color: '#4B5563', fontWeight: 500, fontStyle: 'italic', mb: 2 }}>
                  {data.subtitle}
              </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pb: 3, borderBottom: '1px solid #F1F3F9', color: '#9CA3AF' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                  <UserIcon sx={{ fontSize: 16, color: '#4B5563' }} />
                  <Typography variant="caption" fontWeight={700} sx={{ color: '#4B5563', fontSize: '0.85rem' }}>
                    By {data.seo?.authorName || data.authorName || data.createdBy || 'Admin'}
                  </Typography>
                </Box>
            </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <CalendarIcon sx={{ fontSize: 14 }} />
            <Typography variant="caption">{new Date(data.createdAt).toLocaleDateString()}</Typography>
          </Box>
        </Box>

        <Box
          className="ql-editor ck-content"
          onClick={(e) => {
            const link = e.target.closest('a');
            if (link && link.href) {
              e.preventDefault();
              window.open(link.href, '_blank', 'noopener,noreferrer');
            }
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(restoreImageHostInContent(data.content), {
              ADD_TAGS: ["iframe", "figure", "oembed", "video", "source", "script"],
              ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "src", "data-oembed-url", "url", "width", "height", "style", "title", "loading", "autoplay", "muted", "controls", "playsinline", "srcdoc", "itemprop", "itemtype", "content", "target", "rel"]
            })
          }}
          sx={{
            fontSize: '1rem',
            lineHeight: 1.6,
            color: '#4B5563',
            overflowWrap: 'break-word',
            '& h1, & h2, & h3, & h4, & h5, & h6': { color: '#1F2937', mt: 2, mb: 1, fontWeight: 700 },
            '& p': { mb: 1.5 }
          }}
        />

        {/* Newsletter Unsubscribe Link Preview */}
        {isNewsletter && data.includeUnsubscribeLink !== false && (
          <Box sx={{ mt: 5, pt: 3, borderTop: '1px dashed #E5E7EB', textAlign: 'center' }}>
            <Typography 
              variant="caption" 
              sx={{ color: '#6B7280', fontSize: '0.8rem' }}
              dangerouslySetInnerHTML={{ 
                __html: (() => {
                  const text = data.unsubscribeText || "If you no longer wish to receive these emails, you can unsubscribe here.";
                  if (text.toLowerCase().includes("unsubscribe here")) {
                    return text.replace(/unsubscribe here/i, '<span style="color: #0d3559; text-decoration: underline; font-weight: 600; cursor: pointer;">unsubscribe here</span>');
                  }
                  return `${text} <span style="color: #0d3559; text-decoration: underline; font-weight: 600; cursor: pointer;">unsubscribe here</span>`;
                })()
              }}
            />
          </Box>
        )}
      </Box>
    );
  }

  renderMediaGalleryPreview = (data) => {
    return (
      <Box sx={{ p: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', mb: 3 }}>
              {data.mediaType === 'video' ? (
                <Box sx={{ position: 'relative', pt: '56.25%', bgcolor: 'black' }}>
                  <iframe
                    src={getYouTubeEmbedUrl(data.videoUrl || '')}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={data.title}
                  />
                </Box>
              ) : (
                <img
                  src={resolveImageUrl(data.mediaUrl || data.thumbnail)}
                  alt={data.title}
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2, alignItems: 'center' }}>
                    <Chip 
                        label={this.getCategoryName(data.category).toUpperCase()} 
                        size="small" 
                        sx={{ bgcolor: 'rgba(24, 119, 242, 0.12)', color: '#1877F2', fontWeight: 800, fontSize: '0.7rem' }} 
                    />
                    {data.sort !== undefined && (
                        <Chip
                            label={`ORDER: ${data.sort}`}
                            size="small"
                            sx={{ fontWeight: 800, fontSize: '0.7rem', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.1)', border: 'none' }}
                        />
                    )}
                </Box>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1F2937', mb: 1 }}>{data.title}</Typography>
                {data.subtitle && <Typography variant="h6" sx={{ color: '#4B5563', fontWeight: 500, fontStyle: 'italic', mb: 2 }}>{data.subtitle}</Typography>}

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 3 }}>
                    {[...Array(5)].map((_, i) => (
                        <LightbulbOutlinedIcon key={i} sx={{ color: i < (data.rating || 5) ? '#FFD700' : '#E9ECEF', fontSize: 20 }} />
                    ))}
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#8898AA', mb: 1, textTransform: 'uppercase' }}>Description</Typography>
                    <Box
                      className="ck-content"
                      onClick={(e) => {
                        const link = e.target.closest('a');
                        if (link && link.href) {
                          e.preventDefault();
                          window.open(link.href, '_blank', 'noopener,noreferrer');
                        }
                      }}
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(restoreImageHostInContent(data.content), {
                          ADD_TAGS: ["iframe", "figure", "oembed", "video", "source", "script"],
                          ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "src", "data-oembed-url", "url", "width", "height", "style", "title", "loading", "autoplay", "muted", "controls", "playsinline", "srcdoc", "itemprop", "itemtype", "content", "target", "rel"]
                        })
                      }}
                      sx={{ color: '#4B5563', fontSize: '0.95rem', lineHeight: 1.6 }}
                    />
                </Box>

                {data.ctaLink && (
                    <Button variant="contained" href={data.ctaLink} target="_blank" sx={{ bgcolor: '#0d3559', '&:hover': { bgcolor: '#092a46' }, textTransform: 'none', fontWeight: 700, borderRadius: '8px', px: 4, py: 1.5 }}>
                        {data.ctaText || 'Learn More'}
                    </Button>
                )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderCategoryList = () => {
    const { filter, isLoading, allCategories } = this.state;

    return (
      <Paper elevation={1} style={{ height: 'fit-content', borderRadius: '12px', overflow: 'hidden', border: '1px solid #E9ECEF' }}>
        <Box p={2} sx={{ borderBottom: '1px solid #f1f3f9' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1F2937' }}>Categories</Typography>
            <Tooltip title={this.state.permissions.canCreate ? "Add New Category" : "No Permission"} arrow>
              <IconButton size="small" onClick={() => this.handleCategoryModalOpen('create')} disabled={!this.state.permissions.canCreate}>
                <AddIcon fontSize="small" sx={{ color: this.state.permissions.canCreate ? '#0d3559' : '#8898AA' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box p={1}>
          <List dense sx={{ py: 0 }}>
            <ListItem
              button
              selected={filter === 'All'}
              onClick={() => this.setState({ filter: 'All', page: 1 })}
              disabled={isLoading}
              sx={{
                borderRadius: '8px', mb: 0.5,
                '&.Mui-selected': { bgcolor: 'rgba(13, 53, 89, 0.08) !important', '& .MuiListItemText-primary': { color: '#0d3559', fontWeight: 600 } },
                '&:hover': { bgcolor: 'rgba(13, 53, 89, 0.04)' }
              }}
            >
              <ListItemText primary={<Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: filter === 'All' ? 600 : 400, color: filter === 'All' ? '#0d3559' : '#4B5563' }}>All Resources</Typography>} />
            </ListItem>
            {allCategories.filter(cat => !/^[0-9a-fA-F]{24}$/.test(cat.name)).sort((a, b) => a.name.localeCompare(b.name)).map((cat) => (
              <ListItem
                key={cat._id}
                button
                selected={filter === cat._id}
                onClick={() => this.setState({ filter: cat._id, page: 1 })}
                disabled={isLoading}
                sx={{
                  borderRadius: '8px', mb: 0.5,
                  '&.Mui-selected': { bgcolor: 'rgba(13, 53, 89, 0.08) !important', '& .MuiListItemText-primary': { color: '#0d3559', fontWeight: 600 } },
                  '&:hover': { bgcolor: 'rgba(13, 53, 89, 0.04)' },
                  '&:hover .cat-actions': { display: 'flex' }
                }}
              >
                <ListItemText 
                  primary={<Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: filter === cat._id ? 600 : 400, textTransform: 'capitalize', color: filter === cat._id ? '#0d3559' : '#4B5563' }}>{cat.name}</Typography>} 
                />
                <Box className="cat-actions" sx={{ display: 'none', gap: 0.5 }}>
                  <IconButton 
                    size="small" 
                    disabled={!this.state.permissions.canEdit} 
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleCategoryModalOpen('edit', cat);
                    }}
                  >
                    <EditIcon sx={{ fontSize: 13, color: '#8898AA' }} />
                  </IconButton>
                  {!this.isCoreCategory(cat) && (
                    <IconButton 
                      size="small" 
                      disabled={!this.state.permissions.canDelete} 
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm(`Are you sure you want to delete category "${cat.name}"? This will set all items in this category to "general".`)) {
                          this.handleDeleteCategory(cat);
                        }
                      }}
                    >
                      <DeleteIcon sx={{ fontSize: 13, color: '#ff4d4d' }} />
                    </IconButton>
                  )}
                </Box>
              </ListItem>
            ))}
            <ListItem
              button
              disabled={isLoading || !this.state.permissions.canCreate}
              onClick={() => this.handleCategoryModalOpen('create')}
              sx={{ borderRadius: '8px', border: '1px dashed #E9ECEF', mt: 1, color: this.state.permissions.canCreate ? '#0d3559' : '#8898AA' }}
            >
              <AddIcon sx={{ fontSize: 18, mr: 1 }} />
              <ListItemText primary={<span style={{ fontSize: '0.85rem' }}>Add Category</span>} />
            </ListItem>
          </List>
        </Box>
      </Paper>
    );
  }

  renderHelper = () => (
    <Box sx={{ p: 3, pt: 2 }}>
      <Box sx={{ backgroundColor: '#F8F9FE', borderRadius: '12px', border: '1px solid #E9ECEF', p: 3 }}>
        <Box display="flex" alignItems="center" mb={2} sx={{ color: '#0d3559' }}>
          <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>RESOURCES TIPS</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>Organize Fast:</span> Use the left sidebar to filter content by category. Click "All Resources" to see everything in one view.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>Media Content:</span> When creating "Media Gallery" items, you can now add video URLs and star ratings directly.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="flex-start">
              <ChevronRightIcon sx={{ color: '#0d3559', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#32325D' }}>SEO Optimization:</span> All resources sitting under categories share a unified slug system for better discoverability.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );

  handleModalClose = () => this.setState({ isPreviewOpen: false, previewData: null });

  render() {
    const { cmsData, isLoading, permissions, searchQuery, filter, statusFilter, allCategories } = this.state;
    const { classes } = this.props;

    const activeCatObj = filter === 'All' ? null : allCategories.find(c => c._id === filter || c.slug === filter);
    const catParamValue = activeCatObj ? activeCatObj.slug : (filter !== 'All' ? filter : '');

    const filteredData = cmsData.filter(item => {
      if (item.tag === 'SEARCH_TAGS' || item.tag === 'SEARCH_KEYWORDS') return false;
      const matchesSearch = item.title.toLowerCase().includes(searchQuery.toLowerCase()) || (item.content || '').toLowerCase().includes(searchQuery.toLowerCase());
      const matchesFilter = filter === 'All' || 
        item.categoryId === filter || 
        item.category === filter ||
        (activeCatObj && (item.category === activeCatObj.slug || item.category === activeCatObj._id || item.categoryId === activeCatObj._id));
      const matchesStatus = statusFilter === 'All' || item.status === statusFilter;
      return matchesSearch && matchesFilter && matchesStatus;
    }).sort((a, b) => (parseFloat(a.sort) || 0) - (parseFloat(b.sort) || 0));

    const totalPages = Math.ceil(filteredData.length / this.state.rowsPerPage);
    const paginatedData = filteredData.slice((this.state.page - 1) * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage);

    return (
      <div className={classes.wrapper} style={{ paddingBottom: '40px' }}>
        <Box sx={{ p: 3, pb: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" sx={{ fontWeight: 500, color: '#1F2937' }}>Resources</Typography>
            <Box display="flex" gap={1} alignItems="center">
              <Box sx={{ display: 'flex', bgcolor: '#F1F3F9', p: 0.5, borderRadius: '10px', mr: 2 }}>
                  <Tooltip title="Grid View" arrow>
                      <IconButton 
                          size="small" 
                          onClick={() => this.handleViewModeChange('grid')}
                          sx={{ 
                              bgcolor: this.state.viewMode === 'grid' ? 'white' : 'transparent',
                              color: this.state.viewMode === 'grid' ? '#0d3559' : '#8898AA',
                              boxShadow: this.state.viewMode === 'grid' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                              '&:hover': { bgcolor: this.state.viewMode === 'grid' ? 'white' : 'rgba(0,0,0,0.04)' }
                          }}
                      >
                          <GridViewIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title="List View" arrow>
                      <IconButton 
                          size="small" 
                          onClick={() => this.handleViewModeChange('list')}
                          sx={{ 
                              bgcolor: this.state.viewMode === 'list' ? 'white' : 'transparent',
                              color: this.state.viewMode === 'list' ? '#0d3559' : '#8898AA',
                              boxShadow: this.state.viewMode === 'list' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                              '&:hover': { bgcolor: this.state.viewMode === 'list' ? 'white' : 'rgba(0,0,0,0.04)' }
                          }}
                      >
                          <ViewListIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                  </Tooltip>
              </Box>
              <CodeSnippetHelper />
              <Link to={permissions.canCreate ? `${routes.cmsAiBlog.path}${catParamValue ? `?cat=${catParamValue}` : ''}` : "#"} style={{ textDecoration: 'none' }}>
                <Tooltip title="Smart Generator" arrow>
                  <Button 
                    disabled={!permissions.canCreate} 
                    sx={{ 
                      borderRadius: '12px', 
                      color: '#0d3559', 
                      minWidth: '40px',
                      width: '40px',
                      height: '40px',
                      p: 0,
                      '&:hover': {
                        bgcolor: 'rgba(13, 53, 89, 0.08)',
                        transform: 'translateY(-2px)'
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <SparklesIcon sx={{ fontSize: 22 }} />
                  </Button>
                </Tooltip>
              </Link>
              <Link to={permissions.canCreate ? `${routes.cmsCreate.path}${catParamValue ? `?cat=${catParamValue}` : ''}` : "#"} style={{ textDecoration: 'none' }}>
                <Tooltip title="Create Content" arrow>
                  <Button 
                    disabled={!permissions.canCreate} 
                    sx={{ 
                      borderRadius: '12px', 
                      color: '#0d3559',
                      minWidth: '40px',
                      width: '40px',
                      height: '40px',
                      p: 0,
                      '&:hover': {
                        bgcolor: 'rgba(13, 53, 89, 0.08)',
                        transform: 'translateY(-2px)'
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <AddIcon sx={{ fontSize: 24 }} />
                  </Button>
                </Tooltip>
              </Link>
            </Box>
          </Box>
          <hr style={{ border: 'none', borderTop: '2px solid #F1F3F9', margin: '20px 0' }} />
        </Box>

        {isLoading ? <BrandedLoading /> : (
          <>
            <Box display="flex" gap={4} px={3}>
              <Box width={240} flexShrink={0}>{this.renderCategoryList()}</Box>
              <Box flexGrow={1}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, gap: 2 }}>
                  <TextField
                    variant="outlined" size="small" placeholder="Search resources..." value={searchQuery}
                    onChange={(e) => this.setState({ searchQuery: e.target.value, page: 1 })}
                    sx={{ 
                      flexGrow: 1, 
                      maxWidth: 450, 
                      '& .MuiOutlinedInput-root': { 
                        borderRadius: '8px', 
                        bgcolor: '#FFFFFF',
                        fontSize: '0.875rem',
                        '& fieldset': { borderColor: '#E5E7EB' },
                        '&:hover fieldset': { borderColor: '#0d3559' },
                        '&.Mui-focused fieldset': { borderColor: '#0d3559' }
                      } 
                    }}
                    InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" sx={{ color: '#0d3559', opacity: 0.6 }} /></InputAdornment> }}
                  />
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Typography variant="caption" sx={{ fontWeight: 500, color: '#6B7280' }}>STATUS:</Typography>
                    <Select value={statusFilter} onChange={(e) => this.setState({ statusFilter: e.target.value, page: 1 })} size="small" sx={{ borderRadius: '8px', bgcolor: '#FFFFFF', minWidth: 140, fontSize: '0.875rem' }}>
                      <MenuItem value="All">All Resources</MenuItem>
                      <MenuItem value="draft">Drafts</MenuItem>
                      <MenuItem value="published">Published</MenuItem>
                    </Select>
                  </Box>
                </Box>

                {filteredData.length > 0 ? (
                  <Box>
                    {this.state.viewMode === 'grid' ? (
                      <Grid container spacing={3}>
                        {paginatedData.map((item) => (
                          <Grid item xs={12} sm={6} md={4} key={item._id}>
                            <Box className={classes.blogCard} onClick={() => this.setState({ isPreviewOpen: true, previewData: item })}>
                              <Box sx={{ width: '100%', height: 160, overflow: 'hidden', borderRadius: '12px 12px 0 0', position: 'relative' }}>
                                {item.thumbnail ? <img src={resolveImageUrl(item.thumbnail)} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (
                                  <Box sx={{ width: '100%', height: '100%', bgcolor: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {item.category === 'media gallery' ? <MovieIcon sx={{ fontSize: 44, color: '#9CA3AF' }} /> : <ArticleIcon sx={{ fontSize: 44, color: '#9CA3AF' }} />}
                                  </Box>
                                )}
                                <Box sx={{ position: 'absolute', top: 10, right: 10, display: 'flex', gap: 0.8 }}>
                                  <Tooltip title="Delete Content" arrow>
                                    <IconButton size="small" disabled={!permissions.canDelete} onClick={(e) => { e.stopPropagation(); this.handleDelete(item._id); }} sx={{ bgcolor: '#0d3559', color: '#ff4d4d', '&:hover': { bgcolor: '#092a46' } }}><DeleteIcon sx={{ fontSize: 14 }} /></IconButton>
                                  </Tooltip>
                                  <Tooltip title="Edit Content" arrow>
                                    <IconButton size="small" disabled={!permissions.canEdit} onClick={(e) => { e.stopPropagation(); this.props.history.push(routes.cmsEdit.path(item._id)); }} sx={{ bgcolor: '#0d3559', color: 'white', '&:hover': { bgcolor: '#092a46' } }}><EditIcon sx={{ fontSize: 14 }} /></IconButton>
                                  </Tooltip>
                                  {/* Toggle Publish/Draft Status */}
                                  <Tooltip title={item.status === 'published' ? "Unpublish Content" : "Publish Content"} arrow>
                                    <IconButton 
                                      size="small" 
                                      disabled={!permissions.canEdit} 
                                      onClick={(e) => { e.stopPropagation(); this.handleToggleStatus(item); }} 
                                      sx={{ bgcolor: item.status === 'published' ? 'rgba(237, 108, 2, 0.9)' : 'rgba(46, 125, 50, 0.9)', color: 'white', '&:hover': { bgcolor: item.status === 'published' ? '#e65100' : '#1b5e20' } }}
                                    >
                                      {item.status === 'published' ? <StopIcon sx={{ fontSize: 14 }} /> : <PlayArrowIcon sx={{ fontSize: 14 }} />}
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                                 <Box sx={{ position: 'absolute', top: 10, left: 10, display: 'flex', gap: 0.5 }}>
                                    <Box sx={{ bgcolor: item.status === 'published' ? '#2e7d32' : '#ed6c02', color: 'white', px: 1, py: 0.3, borderRadius: '6px', fontSize: '0.65rem', fontWeight: 500 }}>{(item.status || 'draft').toUpperCase()}</Box>
                                 </Box>
                              </Box>
                              <Box sx={{ p: 2 }}>
                                <Chip label={this.getCategoryName(item.category).toUpperCase()} size="small" sx={{ height: '18px', fontSize: '0.6rem', fontWeight: 500, mb: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '0.9rem', fontWeight: 500, color: '#1F2937', mb: 2, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', height: '2.8em' }}>{item.title}</Typography>
                                <Box sx={{ pt: 2, borderTop: '1px solid #F1F3F9', display: 'flex', justifyContent: 'space-between' }}>
                                  <Typography variant="caption" sx={{ color: '#9CA3AF' }}>{new Date(item.createdAt).toLocaleDateString()}</Typography>
                                  {item.category?.toLowerCase() !== 'newsletter' && item.type !== 'newsletter' && (
                                    <Typography variant="caption" sx={{ color: '#4B5563', fontWeight: 600 }}>{item.seo?.authorName || item.authorName || item.createdBy || 'Admin'}</Typography>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Box sx={{ border: '1px solid #F1F3F9', borderRadius: '16px', overflow: 'hidden', bgcolor: 'white' }}>
                        {paginatedData.map((item, index) => (
                           <Box 
                            key={item._id}
                            onClick={() => this.setState({ isPreviewOpen: true, previewData: item })}
                            sx={{ 
                              p: 2, 
                              display: 'flex', 
                              alignItems: 'center', 
                              gap: 2, 
                              cursor: 'pointer',
                              borderBottom: index === paginatedData.length - 1 ? 'none' : '1px solid #F1F3F9',
                              '&:hover': { bgcolor: '#F8F9FE' }
                            }}
                           >
                              <Box sx={{ width: 60, height: 60, borderRadius: '12px', bgcolor: '#F8F9FE', overflow: 'hidden', flexShrink: 0 }}>
                                {item.thumbnail ? (
                                  <img src={resolveImageUrl(item.thumbnail)} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                  <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {item.category === 'media gallery' ? <MovieIcon sx={{ fontSize: 24, color: '#E9ECEF' }} /> : <ArticleIcon sx={{ fontSize: 24, color: '#E9ECEF' }} />}
                                  </Box>
                                )}
                              </Box>
                              <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#32325D', fontSize: '0.95rem' }}>{item.title}</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography variant="caption" sx={{ color: '#8898AA' }}>{this.getCategoryName(item.category)}</Typography>
                                  <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: '#E9ECEF' }} />
                                  <Typography variant="caption" sx={{ color: '#8898AA' }}>{new Date(item.createdAt).toLocaleDateString()}</Typography>
                                  {item.category?.toLowerCase() !== 'newsletter' && (
                                    <>
                                      <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: '#E9ECEF' }} />
                                      <Typography variant="caption" sx={{ color: '#0d3559', fontWeight: 600 }}>Order: {item.sort || 0}</Typography>
                                    </>
                                  )}
                                </Box>
                              </Box>
                              <Chip 
                                label={(item.status || 'draft').toUpperCase()} 
                                size="small" 
                                sx={{ 
                                  height: '20px', 
                                  fontSize: '0.65rem', 
                                  fontWeight: 800, 
                                  bgcolor: item.status === 'published' ? 'rgba(46, 125, 50, 0.1)' : 'rgba(237, 108, 2, 0.1)',
                                  color: item.status === 'published' ? '#2e7d32' : '#ed6c02',
                                  border: 'none'
                                }} 
                              />
                                <Box sx={{ display: 'flex', gap: 0.5, ml: 'auto' }}>
                                  {/* Toggle Publish/Draft Status */}
                                  <Tooltip title={item.status === 'published' ? "Unpublish Content" : "Publish Content"} arrow>
                                    <IconButton 
                                      size="small" 
                                      disabled={!permissions.canEdit} 
                                      onClick={(e) => { e.stopPropagation(); this.handleToggleStatus(item); }} 
                                      sx={{ color: item.status === 'published' ? '#ed6c02' : '#2e7d32' }}
                                    >
                                      {item.status === 'published' ? <StopIcon sx={{ fontSize: 18 }} /> : <PlayArrowIcon sx={{ fontSize: 18 }} />}
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Edit" arrow>
                                    <IconButton size="small" disabled={!permissions.canEdit} onClick={(e) => { e.stopPropagation(); this.props.history.push(routes.cmsEdit.path(item._id)); }} sx={{ color: '#525F7F' }}><EditIcon sx={{ fontSize: 18 }} /></IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete" arrow>
                                    <IconButton size="small" disabled={!permissions.canDelete} onClick={(e) => { e.stopPropagation(); this.handleDelete(item._id); }} sx={{ bgcolor: 'white', color: '#ff4d4d' }}><DeleteIcon sx={{ fontSize: 18 }} /></IconButton>
                                  </Tooltip>
                                </Box>
                           </Box>
                        ))}
                      </Box>
                    )}
                    {totalPages > 1 && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
                        <Pagination count={totalPages} page={this.state.page} onChange={(e, val) => this.setState({ page: val })} size="large" />
                      </Box>
                    )}
                  </Box>
                ) : (
                  <Box sx={{ py: 12, textAlign: 'center', backgroundColor: '#F8F9FE', borderRadius: '16px', border: '2px dashed #E9ECEF' }}>
                    <SearchIcon sx={{ fontSize: 48, color: '#E9ECEF', mb: 2 }} />
                    <Typography sx={{ color: '#8898AA', fontWeight: 600 }}>No resources found matching your current selection.</Typography>
                  </Box>
                )}
              </Box>
            </Box>
            {this.renderHelper()}
          </>
        )}

        <Modal open={this.state.isPreviewOpen} onClose={this.handleModalClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ width: '90%', maxWidth: 950, maxHeight: '90vh', overflowY: 'auto', bgcolor: 'background.paper', borderRadius: '16px', outline: 'none' }}>
            {this.state.previewData && (
              <Box>
                <Box sx={{ p: 3, borderBottom: '1px solid #F1F3F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h6" sx={{ fontWeight: 800 }}>Preview Content</Typography>
                  <Box display="flex" gap={0.5} alignItems="center">
                    <Tooltip title="Edit Content" arrow>
                        <IconButton 
                            onClick={() => this.props.history.push(routes.cmsEdit.path(this.state.previewData._id))} 
                            disabled={!permissions.canEdit}
                            sx={{ 
                                color: '#0d3559',
                                borderRadius: '10px',
                                '&:hover': { bgcolor: 'rgba(13, 53, 89, 0.08)' }
                            }}
                        >
                            <EditIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    </Tooltip>
                    {/* Toggle Publish/Draft Status */}
                    <Tooltip title={this.state.previewData.status === 'published' ? "Unpublish Content" : "Publish Content"} arrow>
                        <IconButton 
                            onClick={() => {
                                this.handleToggleStatus(this.state.previewData);
                            }} 
                            disabled={!permissions.canEdit}
                            sx={{ 
                                color: this.state.previewData.status === 'published' ? '#ed6c02' : '#2e7d32',
                                borderRadius: '10px',
                                '&:hover': { 
                                    bgcolor: this.state.previewData.status === 'published' ? 'rgba(237, 108, 2, 0.08)' : 'rgba(46, 125, 50, 0.08)'
                                }
                            }}
                        >
                            {this.state.previewData.status === 'published' ? <StopIcon sx={{ fontSize: 20 }} /> : <PlayArrowIcon sx={{ fontSize: 20 }} />}
                        </IconButton>
                    </Tooltip>
                    <IconButton onClick={this.handleModalClose} sx={{ color: '#525F7F' }}><CloseIcon /></IconButton>
                  </Box>
                </Box>
                <Box sx={{ px: 4, pt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Chip label={this.state.previewData.status.toUpperCase()} size="small" sx={{ bgcolor: this.state.previewData.status === 'published' ? '#2e7d32' : '#ed6c02', color: 'white' }} />
                </Box>
                {this.state.previewData.category === 'media gallery' ? this.renderMediaGalleryPreview(this.state.previewData) : this.renderCmsPreview(this.state.previewData)}
              </Box>
            )}
          </Box>
        </Modal>

        <Modal open={this.state.isCategoryModalOpen} onClose={this.handleCategoryModalClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ width: 500, maxHeight: '90vh', overflowY: 'auto', bgcolor: 'background.paper', borderRadius: '16px', p: 4, outline: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: '#32325D' }}>
              {this.state.categoryModalMode === 'create' ? 'Add New Category' : 'Edit Category'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#8898AA', mb: 3 }}>
              {this.state.categoryModalMode === 'create' ? 'Create a new category with a route path.' : `Update "${this.state.editingCategory?.name}" and its route.`}
            </Typography>

            {/* Category Name */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="caption" sx={{ fontWeight: 700, color: '#525F7F', mb: 0.5, display: 'block' }}>
                CATEGORY NAME *
                {this.state.editingCategory && ['blog', 'newsletter', 'social', 'event'].includes(this.state.editingCategory.slug) && (
                  <Typography component="span" variant="caption" sx={{ ml: 1, color: '#ed6c02', fontWeight: 600 }}>
                    (Protected - Cannot Rename)
                  </Typography>
                )}
              </Typography>
              <TextField
                fullWidth
                placeholder="e.g. Blog, News, Events"
                variant="outlined"
                value={this.state.categoryNameInput}
                onChange={(e) => {
                  const name = e.target.value;
                  const slug = name.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
                  this.setState({ 
                    categoryNameInput: name,
                    categoryRoute: `/${slug}`
                  });
                }}
                disabled={this.state.editingCategory && ['blog', 'newsletter', 'social', 'event'].includes(this.state.editingCategory.slug)}
                sx={{ 
                  '& .MuiOutlinedInput-root': { 
                    borderRadius: '8px',
                    bgcolor: this.state.editingCategory && ['blog', 'newsletter', 'social', 'event'].includes(this.state.editingCategory.slug) ? '#F0F0F0' : '#F8F9FE'
                  } 
                }}
                autoFocus={!(this.state.editingCategory && ['blog', 'newsletter', 'social', 'event'].includes(this.state.editingCategory.slug))}
              />
            </Box>

            {/* Category Route */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="caption" sx={{ fontWeight: 700, color: '#525F7F', mb: 0.5, display: 'block' }}>CATEGORY ROUTE *</Typography>
              <TextField
                fullWidth
                placeholder="e.g. /blog, /news, /events"
                variant="outlined"
                value={this.state.categoryRoute}
                onChange={(e) => this.setState({ categoryRoute: e.target.value })}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px', bgcolor: '#F8F9FE' } }}
              />
              <Typography variant="caption" sx={{ color: '#8898AA', mt: 0.5, display: 'block' }}>
                Content URLs will be: {this.state.categoryRoute || '/category'}/content-slug
              </Typography>
            </Box>

            <Box display="flex" justifyContent="flex-end" gap={1.5} sx={{ mt: 3 }}>
              <Button onClick={this.handleCategoryModalClose} sx={{ color: '#525F7F', fontWeight: 600, textTransform: 'none' }}>Cancel</Button>
              <Button 
                variant="contained" 
                onClick={this.handleCategoryModalSubmit}
                disabled={!this.state.categoryNameInput.trim() || !this.state.categoryRoute.trim()}
                sx={{ 
                  bgcolor: '#0d3559', 
                  borderRadius: '10px', 
                  fontWeight: 700, 
                  textTransform: 'none',
                  px: 3,
                  '&:hover': { bgcolor: '#0a2a47' } 
                }}
              >
                {this.state.categoryModalMode === 'create' ? 'Add Category' : 'Save Changes'}
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Newsletter Publish Confirmation Modal */}
        <Modal 
          open={Boolean(this.state.newsletterPublishModal.open)} 
          onClose={() => this.setState({ newsletterPublishModal: { open: false, item: null } })} 
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={{ width: 480, maxWidth: '92vw', bgcolor: 'background.paper', borderRadius: '16px', p: 3.5, outline: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#32325D', fontSize: '1.1rem' }}>
                Publish Newsletter
              </Typography>
              <IconButton size="small" onClick={() => this.setState({ newsletterPublishModal: { open: false, item: null } })} sx={{ color: '#8898AA' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Typography variant="body2" sx={{ color: '#525F7F', mb: 1, fontSize: '0.875rem' }}>
              Choose how you would like to publish this newsletter:
            </Typography>
            
            <Typography variant="body2" sx={{ color: '#32325D', fontWeight: 600, mb: 3, fontSize: '0.875rem', bgcolor: '#F8F9FE', p: 1.5, borderRadius: '8px', border: '1px solid #E9ECEF' }}>
              "{this.state.newsletterPublishModal.item?.title}"
            </Typography>

            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={1.5} sx={{ mt: 2 }}>
              <Button
                onClick={() => this.setState({ newsletterPublishModal: { open: false, item: null } })}
                sx={{ color: '#525F7F', fontWeight: 600, textTransform: 'none', fontSize: '0.85rem' }}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => this.executeNewsletterPublish(this.state.newsletterPublishModal.item, false)}
                sx={{
                  py: 0.8,
                  px: 2,
                  borderRadius: '8px',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  borderColor: '#E2E8F0',
                  color: '#525F7F',
                  '&:hover': { borderColor: '#0d3559', color: '#0d3559', bgcolor: 'rgba(13, 53, 89, 0.04)' }
                }}
              >
                Publish Only
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={() => this.executeNewsletterPublish(this.state.newsletterPublishModal.item, true)}
                startIcon={<NewsletterIcon sx={{ fontSize: '1rem !important' }} />}
                sx={{
                  py: 0.8,
                  px: 2.2,
                  bgcolor: '#0d3559',
                  borderRadius: '8px',
                  fontWeight: 700,
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  '&:hover': { bgcolor: '#0a2a47' }
                }}
              >
                Publish & Send
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Unpublish Confirmation Modal */}
        <Modal 
          open={Boolean(this.state.unpublishModal.open)} 
          onClose={() => this.setState({ unpublishModal: { open: false, item: null } })} 
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Box sx={{ width: 440, maxWidth: '90vw', bgcolor: 'background.paper', borderRadius: '16px', p: 3.5, outline: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#32325D', fontSize: '1.1rem' }}>
                Unpublish Content
              </Typography>
              <IconButton size="small" onClick={() => this.setState({ unpublishModal: { open: false, item: null } })} sx={{ color: '#8898AA' }}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Typography variant="body2" sx={{ color: '#525F7F', mb: 1, fontSize: '0.875rem' }}>
              Are you sure you want to unpublish this content and move it back to draft?
            </Typography>
            <Typography variant="body2" sx={{ color: '#32325D', fontWeight: 600, mb: 3, fontSize: '0.875rem', bgcolor: '#F8F9FE', p: 1.5, borderRadius: '8px', border: '1px solid #E9ECEF' }}>
              "{this.state.unpublishModal.item?.title}"
            </Typography>
            <Box display="flex" justifyContent="flex-end" gap={1.5}>
              <Button 
                onClick={() => this.setState({ unpublishModal: { open: false, item: null } })} 
                sx={{ color: '#525F7F', fontWeight: 600, textTransform: 'none', fontSize: '0.85rem' }}
              >
                Cancel
              </Button>
              <Button 
                variant="contained" 
                size="small"
                onClick={() => this.executeUnpublish(this.state.unpublishModal.item)}
                sx={{ 
                  bgcolor: '#ed6c02', 
                  borderRadius: '8px', 
                  fontWeight: 700, 
                  textTransform: 'none',
                  fontSize: '0.85rem',
                  px: 2.5,
                  py: 0.8,
                  '&:hover': { bgcolor: '#e65100' } 
                }}
              >
                Yes, Unpublish
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    );
  }
}

CmsList.propTypes = {
  classes: PropTypes.object.isRequired,
  messageShow: PropTypes.func.isRequired,
  getCms: PropTypes.func.isRequired,
  removeCms: PropTypes.func.isRequired,
  createOrUpdateCms: PropTypes.func.isRequired,
  createEvent: PropTypes.func.isRequired,
  sendFbPost: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  createOrUpdateCategory: PropTypes.func.isRequired,
  removeCategory: PropTypes.func.isRequired,
};

export default connect(null, {
  messageShow,
  getCms,
  removeCms,
  createOrUpdateCms,
  createEvent,
  sendFbPost,
  getCategories,
  createOrUpdateCategory,
  removeCategory,
  generateBlogFromNews
})(withRouter(withStyles(styles)(CmsList)));
